import { Injectable } from '@angular/core';
import { GenericCharacteristicModel } from 'src/app/core/models/generic-characteristic.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class GenericCharacteristicService extends BaseService<GenericCharacteristicModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'generic-characteristic', authService);
  }
}
